import React, { useState } from 'react';
import AddProductForm from './AddProductForm';
import AddServiceForm from './AddServiceForm';
import './AddItemModal.css';

export default function AddItemForm({ onClose, refreshItems, setUnsavedChanges }) {
  const [active, setActive] = useState('product');

  return (
    <div className="aim">
      <div className="aim-header">
        <h2>{active === 'product' ? 'Product Details' : 'Service Details'}</h2>
        <button className="aim-close" onClick={onClose}>
          ×
        </button>
      </div>

      <div className="aim-tabs">
        <button
          className={active === 'product' ? 'active' : ''}
          onClick={() => setActive('product')}
        >
          Product
        </button>
        <button
          className={active === 'service' ? 'active' : ''}
          onClick={() => setActive('service')}
        >
          Service
        </button>
      </div>

      <div className="aim-body">
        {active === 'product' ? (
          <AddProductForm
            onClose={onClose}
            refreshItems={refreshItems}
            setUnsavedChanges={setUnsavedChanges}
          />
        ) : (
          <AddServiceForm
            onClose={onClose}
            refreshItems={refreshItems}
            setUnsavedChanges={setUnsavedChanges}
          />
        )}
      </div>
    </div>
  );
}
